import React, {Component} from "react";
import {Col} from "reactstrap";
import {Strings} from "./Strings";

export class PrintButton extends Component {
    constructor(props) {
        super(props);
        this.buttonClicked = this.buttonClicked.bind(this);
    }

    buttonClicked(e) {
        e.preventDefault();
        window.print();
    }

    render() {
        return <Col md="4" className="d-flex botSpace headerless">
            <a href={window.location.href} onClick={this.buttonClicked} className="d-flex flex-fill">
                <div className="d-flex flex-fill align-items-center justify-content-center button">
                    <h2 className="button">{Strings.titlePrint}</h2>
                </div>
            </a></Col>
    }
}